import {
  Input,
  Output,
  ViewChild,
  Component,
  OnChanges,
  ElementRef,
  HostListener,
  EventEmitter,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';

import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { CustomComponent, ngHelper } from '@cakeiteasy/web-utils';

import { IFilterCategory } from '../../../models/i-filter-category';


@Component({
  standalone: false,
  selector: 'categories-mobile-selector',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './categories-mobile-selector.component.html',
  styleUrls: ['./categories-mobile-selector.component.scss']
})
export class CategoriesMobileSelectorComponent extends CustomComponent implements OnChanges {
  @ViewChild('container', { static: false }) buttonsContainer: ElementRef<HTMLDivElement>;

  @Input() categories: IFilterCategory[];
  @Input() selectedCategory: IFilterCategory;
  @Input() containerOffsetTop: number;
  @Input() enableScrollingToSelectedCategory = false;
  @Input() showAsSticky = true;

  @Output() onCategorySelected = new EventEmitter<IFilterCategory>();

  public isSticky = false;

  public idPrefix = 'CATEGORY_FOR_FILTERS_';
  public highlightedCategory: IFilterCategory;
  public selectedCategory$ = new Subject<IFilterCategory>();

  constructor() {
    super();
    this.addSubscriber(this.selectedCategory$.pipe(debounceTime(20))
      .subscribe((category) => {
        this.highlightedCategory = category;
        if (this.enableScrollingToSelectedCategory) {
          this.horizontalScrollToCategory(category.id);
        }
      }));
  }

  @HostListener('window:scroll')
  onScroll() {
    if (this.showAsSticky) {
      requestAnimationFrame(() => {
        this.isSticky = window.scrollY >= this.containerOffsetTop;
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    ngHelper.ifChanged(changes, 'selectedCategory', (category) => {
      this.selectedCategory$.next(category);
    });
  }

  horizontalScrollToCategory(categoryId: number, duration = 10) {
    const container = this.buttonsContainer.nativeElement;
    const selector = '#' + this.idPrefix + categoryId;
    const button = container.querySelector(selector);
    let { left: buttonLeft, width: buttonWidth } = button.getBoundingClientRect();

    let scrollTo = 0;
    const visibleContainerWidth = container.getBoundingClientRect().width;
    const hiddenRightButtonSection = (buttonLeft + buttonWidth) - visibleContainerWidth;

    // added and removing buttonWidth to get next/prev button
    if (hiddenRightButtonSection > -buttonWidth / 2) {
      scrollTo = hiddenRightButtonSection + 80;
    } else if (buttonLeft < container.scrollLeft) {
      scrollTo = buttonLeft - 60;
    }

    const step = scrollTo / duration;

    const move = (scrollDistance = 0) => {
      requestAnimationFrame(() => {
        if (scrollDistance < 1 && scrollDistance > -1) {
          return;
        }

        container.scrollLeft = this.buttonsContainer.nativeElement.scrollLeft + step;
        move(scrollDistance - step);
      });
    };
    move(scrollTo);
  }

  public selectCategory(category: IFilterCategory) {
    this.highlightedCategory = category;
    this.onCategorySelected.emit(category);

    if (this.enableScrollingToSelectedCategory) {
      this.horizontalScrollToCategory(category.id);
    }
  }
}
